export class Response {
    errorCode: string;
    returnObject: any;

    constructor(obj: any = {}) {
        this.errorCode = obj && obj.errorCode || null;
        this.returnObject = obj && obj.returnObject || null;
    }
}
